import {createApp} from 'vue'
import App from './App.vue'

import zhCn from 'element-plus/es/locale/lang/zh-cn'


const app = createApp(App)

// 引入路由对象实例
import router from './router/router.js'

app.use(router)

import ElementPlus from 'element-plus'
import './style/ElementCss.scss'
// import 'element-plus/theme-chalk/index.css'

import Vant from 'vant';
import 'vant/lib/index.css';

app.use(Vant);

app.use(ElementPlus, {size: 'default', zIndex: 3000, locale: zhCn,})

app.mount('#app')
